import React from 'react';

export const SupportContactsModalPeopleAtAxiom = () => {
  return (
    <a
      data-test="PAX_EMAIL_LINK"
      href="mailto:dl_pax_for_legal_talent@axiomlaw.com"
    >
      dl_pax_for_legal_talent@axiomlaw.com{' '}
    </a>
  );
};
